import React, { useEffect, useState } from "react";
import CommonNavbar from "./CommonNavbar";
import ariesImage from "../assets/zodiacimage/aries1.png";
import taurusImage from "../assets/zodiacimage/taurus1.png";
import geminiImage from "../assets/zodiacimage/gemini.png";
import cancerImage from "../assets/zodiacimage/cancer.png";
import leoImage from "../assets/zodiacimage/leo1.png";
import virgoImage from "../assets/zodiacimage/virgo.png";
import libraImage from "../assets/zodiacimage/libra.png";
import scorpioImage from "../assets/zodiacimage/scorpio.png";
import sagittariusImage from "../assets/zodiacimage/sagittarius.png";
import capricornImage from "../assets/zodiacimage/capricorn.png";
import aquariusImage from "../assets/zodiacimage/aquarius1.png";
import piscesImage from "../assets/zodiacimage/pisces.png";
import rings from "../assets/rootimg/two-rings.png";
import compatibility from "../assets/rootimg/compatibility.png";
import dailytarotImage from "../assets/zodiacSign/dailytarot.png";
import { MdOutlineArrowDropDown } from "react-icons/md";
import Footer from "../home/Footer";
import Queryform from "./Queryform";
import { useNavigate } from "react-router";
import Navbar from "../home/Navbar";
import BlogRecommendations from "./AstroBlog/BlogRecommendations";

const Horoscope = () => {
    const [isActive, setIsActive] = useState(null);
    const zodiacSigns = [
        { name: "Aries", Image: ariesImage },
        { name: "Taurus", Image: taurusImage },
        { name: "Gemini", Image: geminiImage },
        { name: "Cancer", Image: cancerImage },
        { name: "Leo", Image: leoImage },
        { name: "Virgo", Image: virgoImage },
        { name: "Libra", Image: libraImage },
        { name: "Scorpio", Image: scorpioImage },
        { name: "Sagittarius", Image: sagittariusImage },
        { name: "Capricorn", Image: capricornImage },
        { name: "Aquarius", Image: aquariusImage },
        { name: "Pisces", Image: piscesImage },
    ];

    const [month, setMonth] = useState("");
    const [day, setDay] = useState("");
    const [year, setYear] = useState("");
    const [zodiacSign, setZodiacSign] = useState("");

    const getZodiacSign = (month, day) => {
        if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return 'Aries';
        if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return 'Taurus';
        if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) return 'Gemini';
        if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) return 'Cancer';
        if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return 'Leo';
        if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return 'Virgo';
        if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) return 'Libra';
        if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) return 'Scorpio';
        if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) return 'Sagittarius';
        if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) return 'Capricorn';
        if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) return 'Aquarius';
        if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) return 'Pisces';
        return '';
    };


    const handleSubmit = () => {
        if (month && day) {
            const sign = getZodiacSign(Number(month), Number(day));
            setZodiacSign(sign);
        } else {
            alert("Please select a valid date.");
        }
    };
    const navigate = useNavigate();
    const dailyHoroscope = (e, sign) => {
        e.preventDefault();
        navigate('/daily-horoscope', { state: { zodiacSign: sign } });
    }
    const kundliClick = (e) => {
        e.preventDefault();
        navigate('/kundlimatching');
    }
    const tarotClick = (e) => {
        e.preventDefault();
        navigate('/tarot');
    }
    const compatibilityClick = (e) => {
        e.preventDefault();
        navigate('/compatibility');
    }
 
    return (
        <>
            <div className="">
                <section>
                    <div className="min-h-screen bg-gradient-to-r from-white to-success/40 text-gray-900">
                        <Navbar />
                        <main className="container mx-auto px-4 items-center py-8 ">
                            <h1 className='text-4xl font-bold text-center font-serif text-secondary mt-6 sm:mb-2 '>HOROSCOPE</h1>
                            <p className="text-lg mb-4 font-serif text-secondary text-center mx-auto max-w-2xl">
                                Start your day with this horoscope to align your energy, embrace new opportunities, and gain clarity on any obstacles that may come your way.
                            </p>

                            <div className="text-center mb-5">
                                <h2 className="text-2xl font-serif font-semibold mb-4 text-secondary">Find Out Your Zodiac Sign</h2>
                                <div className="flex flex-wrap justify-center gap-4">
                                    <div className="relative w-full sm:w-40 md:w-48">
                                        <select
                                            className="w-full border p-3 text-center outline-none rounded-md shadow-sm text-lg appearance-none"
                                            defaultValue=""
                                            onChange={(e) => setMonth(e.target.value)}
                                        >
                                            <option value="" disabled>Month</option>
                                            {Array.from({ length: 12 }, (_, i) => (
                                                <option key={i} value={i + 1}>
                                                    {new Date(0, i).toLocaleString("default", { month: "long" })}
                                                </option>
                                            ))}
                                        </select>
                                        <MdOutlineArrowDropDown className="absolute right-4 top-1/2 transform -translate-y-1/2 text-xl" />
                                    </div>

                                    <div className="relative w-full sm:w-32 md:w-40">
                                        <select
                                            className="w-full border p-3 text-center outline-none rounded-md shadow-sm text-lg appearance-none"
                                            defaultValue=""
                                            onChange={(e) => setDay(e.target.value)}
                                        >
                                            <option value="" disabled>Day</option>
                                            {Array.from({ length: 31 }, (_, i) => (
                                                <option key={i} value={i + 1}>{i + 1}</option>
                                            ))}
                                        </select>
                                        <MdOutlineArrowDropDown className="absolute right-4 top-1/2 transform -translate-y-1/2 text-xl" />
                                    </div>

                                    <div className="relative w-full sm:w-32 md:w-40">
                                        <select
                                            className="w-full border p-3 text-center outline-none rounded-md shadow-sm text-lg appearance-none"
                                            defaultValue=""
                                            onChange={(e) => setYear(e.target.value)}
                                        >
                                            <option value="" disabled>Year</option>
                                            {Array.from({ length: 100 }, (_, i) => (
                                                <option key={i} value={1965 + i}>{1965 + i}</option>
                                            ))}
                                        </select>
                                        <MdOutlineArrowDropDown className="absolute right-4 top-1/2 transform -translate-y-1/2 text-xl" />
                                    </div>

                                    <button
                                        onClick={handleSubmit}
                                        className="w-full sm:w-40 md:w-48 px-4 py-3 text-lg font-bold bg-secondary text-white rounded-md shadow hover:bg-primary/90 transition duration-300"
                                    >
                                        Find My Sign
                                    </button>
                                </div>

                                {zodiacSign && (
                                    <div className="mt-4 text-lg">
                                        <div className="mt-2 flex flex-col items-center rounded-md">
                                            <div className="bg-gradient-to-r from-success to-[#9034E9] p-4 rounded-md">
                                                <img
                                                    src={zodiacSigns.find((sign) => sign.name === zodiacSign)?.Image}
                                                    alt={zodiacSign}
                                                    className="mx-auto w-14 h-14 sm:w-10 sm:h-10 md:w-20 md:h-20 lg:w-20 lg:h-20 ring-4 object-cover ring-white shadow-custom-shadow rounded-full mb-2 sm:mb-3"
                                                    // style={{ width: '100px', height: '100px' }}
                                                />
                                                <div className="mt-2 font-bold text-white">{zodiacSign}</div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            
                                {/* horoscope sign card */}
                            <div className="grid grid-cols-3 md:grid-cols-6 lg:grid-cols-6 gap-2 sm:gap-3 md:gap-2 lg:gap-6 lg:mt-8 lg:mx-auto max-w-6xl sm:mt-5 mx-auto text-center">
                                {/* horoscope div card */}
                                {zodiacSigns.map((sign, index) => (
                                    <div
                                        key={index}
                                        className="p-3 sm:p-4 rounded-lg hover:shadow-custom-shadow bg-gradient-to-r from-success to-[#9034E9] transition duration-300 cursor-pointer"
                                        onMouseEnter={() => setIsActive(index)}
                                        onMouseLeave={() => setIsActive(null)}
                                        onClick={(e) => dailyHoroscope(e, sign.name)}
                                    >
                                        <img
                                            src={sign.Image}
                                            alt={sign.name}
                                            className="mx-auto w-14 h-14 sm:w-10 sm:h-10 md:w-20 md:h-20 lg:w-20 lg:h-20 ring-4 object-cover ring-white shadow-custom-shadow rounded-full mb-2 sm:mb-3"
                                        />
                                        <span className={`text-xs sm:text-sm md:text-base font-bold text-white ${isActive === index ? "underline" : ""}`}>
                                            {sign.name}
                                        </span>
                                    </div>
                                ))}
                            </div>
                            
                        </main>

                        <BlogRecommendations />
                        
                        <div className="mt-10 flex flex-col container mx-auto justify-center items-center">
                                <h1 className="text-center text-lg sm:text-xl md:text-2xl text-secondary  font-bold">
                                    Recommended Reports For You
                                </h1>
                                {/* Parent Card div */}
                                <div className="flex flex-wrap gap-5 justify-center mt-5">
                                    {/* Card 1 */}
                                    <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
                                        <div className="flex flex-col items-center">
                                            <img
                                                src={rings}
                                                alt="kundli.png"
                                                className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                                            />
                                            <div className="text-center">
                                                <h3 className="text-lg sm:text-xl font-bold mb-2 text-center text-secondary">Kundli Matching</h3>
                                                <p className="text-justify text-xs sm:text-sm md:text-base m-3 mb-4">
                                                    Kundli Matching helps you find a match for your astrological traits and preferences. By comparing your birth
                                                    chart with others in the database, you can find a person who shares your similarities, characteristics, and
                                                    compatible energies.
                                                </p>
                                                <button
                                                    onClick={kundliClick}
                                                    className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                                                >
                                                    Match Kundli
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Card 2 */}
                                    <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
                                        <div className="flex flex-col items-center">
                                            <img
                                                src={dailytarotImage}
                                                alt="daily-horoscope.png"
                                                className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                                            />
                                            <div className="text-center">
                                                <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Tarot Rading</h3>
                                                <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-6">
                                                    Tarot reading provides guidance by revealing hidden energies, emotions, and possibilities. By drawing cards
                                                    and interpreting meanings, you gain clarity on challenges, relationships, and opportunities. Each reading empowers
                                                    you to make informed decisions.

                                                </p>
                                                <button
                                                    onClick={tarotClick}
                                                    className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                                                >
                                                    Start Reading
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Card 3 */}
                                    <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
                                        <div className="flex flex-col items-center">
                                            <img
                                                src={compatibility}
                                                alt="daily-horoscope.png"
                                                className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                                            />
                                            <div className="text-center">
                                                <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Compatibility</h3>
                                                <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-4">
                                                    Compatibility helps you understand how well your astrological traits
                                                    align with those of another person. By comparing your birth chart with
                                                    others in the database, you can find a person who shares your
                                                    similarities and characteristics.
                                                </p>
                                                <button
                                                    onClick={compatibilityClick}
                                                    className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                                                >
                                                    Check Compatibility
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        <Queryform />
                        <Footer />
                    </div>
                </section>
            </div>
        </>
    );
};

export default Horoscope;